import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/root-reducer';
import { AppDispatch } from 'store';
import { AuthState } from './auth-slice';

export function useAuth(): [AuthState, AppDispatch] {
  const authSelector = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  return [authSelector, dispatch];
}
